angular.module("ainapp")
    .controller("liabilitiesBalanceController", ["app.config", "$scope", "$http", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window", function (config, $scope, $http, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

        $scope.PageName = "Liabilities Balance";
        $scope.TokenInfo = AuthenticationService.getTokenInfo();
        if ($scope.TokenInfo == null) {
            $state.go("login");
        } else {
            $scope.checkUserPageAccess($scope.PageName);
        }

        $scope.filterFn = function () {

            $scope.filter.Type = $scope.ViewVal;

            $scope.filter.FromMonth = $scope.filter.FromDate.getMonth() + 1;
            $scope.filter.FromDay = $scope.filter.FromDate.getDate();
            $scope.filter.FromYear = $scope.filter.FromDate.getFullYear();

            $scope.filter.ToMonth = $scope.filter.ToDate.getMonth() + 1;
            $scope.filter.ToDay = $scope.filter.ToDate.getDate();
            $scope.filter.ToYear = $scope.filter.ToDate.getFullYear();


            $scope.Load = true;
            $http.post(config.basePath + "getLiabilitiesBalances", $scope.filter).then(function (response) {
                $scope.Balances = response.data;
                $scope.Load = false;
            }, function (err) {
                $scope.Load = false;
                toastr.error("Some Error Occured");
            })
        }


        $scope.init = function () {

            $scope.Load = false;
            $scope.Balances = [];
            $scope.ViewVal = "Equity Capital Balance";

            $scope.date1 = new Date();
            var n = $scope.date1.getFullYear();
            $scope.d2 = new Date("01/01/" + n);

            $scope.filter = {
                FromDate: $scope.d2,
                ToDate: new Date(),
                DocNo: "",
            }

            $scope.finyear = {};
            MainService.getCurrentFinancialYear().then(function (response) {
                $scope.finyear = response.data;
                $scope.filter.FromDate = new Date($scope.finyear.StartDate);
            });
            $scope.filterFn();

        }
        $scope.init();


        //        $scope.PageName = "General Ledger";
        //        $scope.TokenInfo = AuthenticationService.getTokenInfo();
        //        if ($scope.TokenInfo == null) {
        //            $state.go("login");
        //        } else {
        //            if ($scope.TokenInfo.Role != 'Admin' && $scope.TokenInfo.Role != 'admin' && $scope.TokenInfo.Role != '0' && $scope.TokenInfo.Role != 'SU') {
        //                var data = {
        //                    PageName: $scope.PageName,
        //                    UserId: $scope.TokenInfo.Id,
        //                }
        //                MainService.CheckUserPageAccess(data).then(function (response) {
        //                    if (response.data == true) {
        //                        $scope.init();
        //                    } else {
        //                        $state.go("forbidden");
        //                    }
        //                }, function (err) {
        //                    toastr.error("Network Error");
        //                });
        //            } else {
        //                $scope.init();
        //            }
        //        }


        $scope.changeView = function (val) {
            $scope.ViewVal = val;
            $scope.filterFn();
        }

        $scope.Reset = function () {
            $scope.init();
            $scope.filterFn();
        }





    }]);
